import toastr from 'toastr'
import { hasPermits } from 'directives'
import { confirm } from 'components/modals'
import formModal from './formModal'

const components = {
  formModal,
  confirm
}

const directives = {
  hasPermits
}

const computed = {
  apiRateLimits () {
    let list = _.cloneDeep(this.$store.state.channels.active.api_rate_limits)
    if (_.isArray(list)) {
      return list
    }
    if (list && _.isArray(list.data)) {
      return list.data
    }
    return []
  }
}

const methods = {
  getApiRateLimits () {
    this.loading = true
    this.$store.dispatch('channels.getApiRateLimits', {
      channel_id: this.$route.params.id,
      params: { _all: true }
    }).then(() => {
      this.loading = false
      let errors = this.$store.state.channels.errors
      if (errors) {
        toastr.error(errors.message)
      }
    })
  },

  openCreateModal () {
    this.$refs.formModal.open()
  },

  openEditModal (item) {
    this.$refs.formModal.open(item)
  },

  formatWindow (seconds) {
    const labels = {
      60: '1 minute',
      300: '5 minutes',
      600: '10 minutes',
      1800: 'Half hour (30 min)',
      3600: '1 hour',
      86400: '1 day'
    }
    if (labels[seconds]) {
      return `${labels[seconds]}(${seconds}s)`
    }
    return `${seconds}s`
  },

  removeItem (item) {
    this.$refs.confirmDelete.confirm('Are you sure you want to delete this rate limit?', () => {
      this.deleteLoadings[item.id] = true
      this.deleteLoadings = _.cloneDeep(this.deleteLoadings)
      this.$store.dispatch('channels.removeApiRateLimit', {
        channel_id: this.$route.params.id,
        id: item.id
      }).then(() => {
        this.deleteLoadings[item.id] = false
        this.deleteLoadings = _.cloneDeep(this.deleteLoadings)
        let errors = this.$store.state.channels.errors
        if (errors) {
          toastr.error(errors.message)
        } else {
          toastr.success('Rate limit removed successfully')
        }
      })
    })
  }
}

const watch = {
  activeTab (n) {
    if (n && n.title == 'API Rate Limits') {
      this.getApiRateLimits()
    }
  }
}

export default {
  name: 'api-rate-limit-tab',
  props: ['activeTab', 'formData'],
  components,
  directives,
  computed,
  methods,
  watch,
  data () {
    return {
      loading: false,
      deleteLoadings: {}
    }
  },
  created () {
    if (this.activeTab && this.activeTab.title == 'API Rate Limits') {
      this.getApiRateLimits()
    }
  }
}
